import React, { useEffect, useState } from "react";
import ProductCard from "@/components/ProductCard";
import { api } from "@/lib/api";

const AUDIENCE_FILTERS = [
  { value: "", label: "Tous" },
  { value: "homme", label: "Homme" },
  { value: "femme", label: "Femme" },
  { value: "enfant", label: "Enfant" },
];

const CATEGORY_FILTERS = [
  { value: "", label: "Toutes" },
  { value: "chaines", label: "Chaînes" },
  { value: "bracelets", label: "Bracelets" },
  { value: "boucles", label: "Boucles" },
  { value: "ensembles", label: "Ensembles" },
  { value: "chaussures", label: "Chaussures" },
  { value: "accessoires", label: "Accessoires" },
];

export default function Catalog() {
  const [products, setProducts] = useState([]);
  const [audience, setAudience] = useState("");
  const [category, setCategory] = useState("");
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/products").then((r) => setProducts(r.data)).finally(() => setLoading(false));
  }, []);

  const filtered = products.filter((p) => {
    if (audience && p.audience !== audience) return false;
    if (category && p.category !== category) return false;
    if (search && !p.name.toLowerCase().includes(search.toLowerCase())) return false;
    return true;
  });

  return (
    <div className="max-w-7xl mx-auto px-6 lg:px-10 py-16 lg:py-24">
      <div className="label-tiny mb-3 flex items-center gap-3">
        <span className="gold-line" /> Catalogue Complet
      </div>
      <h1 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight mb-12">
        {`L'ensemble de nos pièces`}
      </h1>

      <div className="grid lg:grid-cols-[260px_1fr] gap-8">
        <aside className="space-y-8">
          <div>
            <label className="label-tiny block mb-3">Rechercher</label>
            <input
              type="text"
              placeholder="Nom du produit..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              className="input-gold"
              data-testid="catalog-search-input"
            />
          </div>
          <div>
            <div className="label-tiny mb-3">Public</div>
            <div className="space-y-1.5">
              {AUDIENCE_FILTERS.map((f) => (
                <button
                  key={f.value}
                  onClick={() => setAudience(f.value)}
                  data-testid={`cat-audience-${f.value || "all"}`}
                  className={`block w-full text-left px-3 py-2 text-sm transition ${
                    audience === f.value
                      ? "bg-[#B8860B] text-[#0A0A0A]"
                      : "text-[#1A1A1A]/75 hover:text-[#B8860B]"
                  }`}
                >
                  {f.label}
                </button>
              ))}
            </div>
          </div>
          <div>
            <div className="label-tiny mb-3">Catégorie</div>
            <div className="space-y-1.5">
              {CATEGORY_FILTERS.map((f) => (
                <button
                  key={f.value}
                  onClick={() => setCategory(f.value)}
                  data-testid={`cat-category-${f.value || "all"}`}
                  className={`block w-full text-left px-3 py-2 text-sm transition ${
                    category === f.value
                      ? "bg-[#B8860B]/10 text-[#B8860B] border-l-2 border-[#B8860B]"
                      : "text-[#1A1A1A]/75 hover:text-[#B8860B] border-l-2 border-transparent"
                  }`}
                >
                  {f.label}
                </button>
              ))}
            </div>
          </div>
        </aside>

        <div>
          {loading ? (
            <div className="py-20 text-center text-[#6B6B6B]">Chargement...</div>
          ) : filtered.length === 0 ? (
            <div className="py-20 text-center border border-black/5">
              <p className="text-[#6B6B6B]">Aucun produit trouvé.</p>
            </div>
          ) : (
            <>
              <div className="mb-6 text-xs text-[#6B6B6B] tracking-widest uppercase">
                {filtered.length} {filtered.length > 1 ? "pièces" : "pièce"}
              </div>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8" data-testid="catalog-product-grid">
                {filtered.map((p) => (
                  <ProductCard key={p.id} product={p} />
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
